module.exports = __webpack_public_path__ + "fonts/motiva-sans-light-italic.931e9d6.otf";